import { createStyles, makeStyles } from "@material-ui/core";
import imageBox from "assets/icons/default_product_picture.svg";
import { ProductContext } from "contexts/ProductContext";
import { BoxIcon, PriceIcon } from "icons";
import React from "react";
import { renderImageArticle, truncateMessage } from "utils";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
    },
    imgContent: {
      height: 280,
      width: 280,
      margin: "0px 10px 0px 0px",
    },
    descriptionContent: {
      height: 300,
      width: 300,
      margin: "0px 0px 0px 10px",
    },
    img: {
      height: "100%",
      width: "100%",
      borderRadius: 7,
    },
    title: {
      fontWeight: 900,
      color: "#414142",
      fontSize: "16pt",
    },
    description: {
      fontSize: 11,
      color: "#c5c5c5",
      marginTop: 10,
      marginBottom: 10,
      height: "70%",
    },
    lines: {
      display: "flex",
      justifyContent: "space-between",
    },
    lineItem: {
      color: "#5a525b",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly",
      fontSize: 12,
      "&>span": {
        marginLeft: 2,
      },
    },
  })
);

export function RecapForm() {
  const styles = useStyles();
  const { product, image } = React.useContext(ProductContext);

  return (
    <div className={styles.root}>
      <div className={styles.imgContent}>
        <img
          src={image ? renderImageArticle(image) : product.photoUrl ?? imageBox}
          alt="product"
          className={styles.img}
        />
      </div>
      <div className={styles.descriptionContent}>
        <div className={styles.title}>{truncateMessage(product.name, 20)}</div>
        <div className={styles.description}>{truncateMessage(product.description, 370)}</div>
        <div className={styles.lines}>
          <div className={styles.lineItem}>
            <span>
              <BoxIcon color="#f69833" height={20} width={20} />
            </span>
            <span>{product.weight}</span>
          </div>
          <div className={styles.lineItem}>
            <span>
              <PriceIcon color="#f69833" height={20} width={20} />
            </span>
            <span>{product.value} XOF</span>
          </div>
          <div />
        </div>
      </div>
    </div>
  );
}
